import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditSaveHandler,
  isPageEditFalse,
} from "../CommonComponent/EditSaveHandler";
import {
  SubmitApprovalRequestAction,
  ViewRequestStatusAction,
} from "../../../redux/actions/GlobalAction";
import Select from "react-select";
import {
  getInfrastructureDetailsAction,
  getTimeSlotAction,
  getWorkingHoursSlotAction,
  updateInfrastructureDetailsAction,
} from "../../../redux/actions/InfrastructureDetailsAction";
import { MandatoryStar } from "../../../Utils/helper";
import FacilitiyImage from "./FacilitiyImage";
import {
  centerInfrastructure,
  colourStyles,
  Option,
  weekRecords,
} from "./helper";
import { SlotPickerPopup } from "./SlotPickerPopup";
import { getCampaignsToken, getNetworkMenuId, getProviderPortalId, getRole } from "../../../Utils/types";
import ROUTES from "../../../Utils/routesConstants";
import { addProviderAssitLogAction } from "../../../redux/actions/ProviderAssistAction";
import { useLocation, useParams } from "react-router-dom";

const InfrastructureDetails = () => {
  const location = useLocation()
  const urlParams = useParams();
  let source = location?.search.split("=")[1]
  localStorage.setItem("campaignsToken", urlParams?.token);

  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [isOpenSelectTime, setIsOpenSelectTime] = useState(false);
  const [weekSlotData, setWeekSlotData] = useState(null);
  const [weekSlotName, setWeekSlotName] = useState(null);
  const [sortToTiming, setSortToTiming] = useState([]);
  const [modalPopupDetail, setModalPopupDetail] = useState({});
  useEffect(() => {
    dispatch(getInfrastructureDetailsAction());
    dispatch(getTimeSlotAction("", ""));
  }, []);

  const getInfrastructureDetails = useSelector(
    (state) =>
      state?.InfrastructureDetailsReducer?.getInfrastructureDetails
        ?.infrastructureDetails
  );
  const isShowSubmitButton = useSelector(
    (state) =>
      state?.InfrastructureDetailsReducer?.getInfrastructureDetails
        ?.isShowSubmitButton
  );

  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);
  const getTimeSlot = useSelector(
    (state) => state?.InfrastructureDetailsReducer?.getTimeSlot
  );

  useEffect(() => {
    dispatch(getInfrastructureDetailsAction());
    dispatch(getTimeSlotAction("", ""));
  }, []);

  useEffect(() => {
    if (data?.regularTimingFrom && getTimeSlot?.length) {
      const checkingArray = getTimeSlot?.map((ele) => ele?.startTime);
      const index = checkingArray.indexOf(data?.regularTimingFrom);
      const temp = checkingArray.slice(index + 1);
      setSortToTiming(temp);
    }
  }, [data?.regularTimingFrom, getTimeSlot]);

  useEffect(() => {
    if (getInfrastructureDetails && !isPageEdit) {
      setData(getInfrastructureDetails);
    }
    dispatch(
      getWorkingHoursSlotAction(
        getInfrastructureDetails?.regularTimingFrom,
        getInfrastructureDetails?.regularTimingTo
      )
    );
  }, [getInfrastructureDetails, isPageEdit]);

  const changeHandler = (name, value) => {
    setData({ ...data, [name]: value });
  };

  const SaveHandler = async (event) => {
    event.preventDefault();
    await dispatch(updateInfrastructureDetailsAction(source === "WhatsApp" || source === "Email"? {...data,source:source}:getRole() === "NetworkAdmin" ? {...data,source:"Network"} : data));
    await dispatch(getInfrastructureDetailsAction());
    await isPageEditFalse(dispatch);
    await dispatch(ViewRequestStatusAction("InfrastructureDetail"));
    window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
      (await dispatch(
        addProviderAssitLogAction({
          providerId: getProviderPortalId(),
          moduleName: "InfrastructureDetail",
          actionFlag: "E",
        })
      ));
  };

  return (
    <div className={`main-section ${location?.pathname !==  "/infrastructure-details" ? "infraOpenUrls" :""}`}>
      <form onSubmit={SaveHandler}>
        <div className={`right-section ${location?.pathname !==  "/infrastructure-details" ? "infraOpenUrlRightSec" :""}`} >
          <div className="card Infrastructure-details-section">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center edit-save-css">
                <h4>Infrastructure Details</h4>
                {((getNetworkMenuId()?.canEdit && getRole() === "NetworkAdmin") || getRole() === "ServiceProvider" || getCampaignsToken() !== undefined) &&
                  <EditSaveHandler
                    isShowViewButton={isShowSubmitButton}
                    moduleName="InfrastructureDetail"
                  />}
              </div>
              <div className="row area-infrastructure">
                <div className="col-md-3">
                  <div className="mt-4">
                    <label className="form-label mb-4">
                      Total Area of Facility in Sq. F
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={data?.areaOfFacility}
                      onChange={(e) =>
                        changeHandler(
                          "areaOfFacility",
                          e.target.value === "" ? null : e?.target.value
                        )
                      }
                      pattern="[0-9]+"
                      disabled={!isPageEdit}
                      onKeyPress={(event) => {
                        const re = /[0-9]+/g;
                        if (!re.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mt-4">
                    <label className="form-label mb-4">
                      Total Area of Waiting in Sq.
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={data?.areaOfWaitingRoom}
                      onChange={(e) =>
                        changeHandler(
                          "areaOfWaitingRoom",
                          e.target.value === "" ? null : e?.target.value
                        )
                      }
                      pattern="[0-9]+"
                      disabled={!isPageEdit}
                      onKeyPress={(event) => {
                        const re = /[0-9]+/g;
                        if (!re.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mt-4">
                    <label className="form-label mb-4">
                      Client Handling Capacity
                    </label>
                    <div className="row">
                      <div className="col-6 d-flex">
                        <span
                          style={{ display: "inline-block", minWidth: "70px" }}
                        >
                          Per Day
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={data?.clientHandlingCapacityPerDay}
                          pattern="[0-9]+"
                          onChange={(e) =>
                            changeHandler(
                              "clientHandlingCapacityPerDay",
                              e.target.value === "" ? null : e?.target.value
                            )
                          }
                          disabled={!isPageEdit}
                          onKeyPress={(event) => {
                            const re = /[0-9]+/g;
                            if (!re.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </div>
                      <div className="col-6 d-flex">
                        <span
                          style={{ display: "inline-block", minWidth: "70px" }}
                        >
                          Per Hour
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          pattern="[0-9]+"
                          value={data?.clientHandlingCapacityPerHour}
                          onChange={(e) =>
                            changeHandler(
                              "clientHandlingCapacityPerHour",
                              e.target.value === "" ? null : e?.target.value
                            )
                          }
                          onKeyPress={(event) => {
                            const re = /[0-9]+/g;
                            if (!re.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          disabled={!isPageEdit}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="center-infrastructure">
                <h2>Centre Infrastructure</h2>
                {centerInfrastructure?.map((ele, index) => {
                  return (
                    <div
                      className="form-check form-check-inline infrastructure-cheack-box"
                      key={index}
                    >
                      <input
                        type="checkbox"
                        name={ele?.label}
                        value={data?.[ele?.value]}
                        onClick={(e) =>
                          isPageEdit &&
                          changeHandler(
                            ele?.value,
                            e.target.checked ? true : false
                          )
                        }
                        checked={data?.[ele?.value]}
                        className="form-check-input"
                      />
                      <label htmlFor={ele?.label} className="margin-right">
                        {ele?.label}
                      </label>
                    </div>
                  );
                })}
              </div>
              <div className="working-day-section">
                <div style={{ display: "flex" }}>
                  <div className="working-day-header d-flex align-items-center flex-wrap mt-3">
                    <div style={{ display: "flex" }}>
                      <h2>Working Hours</h2>
                    </div>
                    <div
                      className="working-day-input"
                      style={{ display: "flex" }}
                    >
                      <h2 className="select-start-time">From</h2>
                      <div>
                        <Select
                          options={getTimeSlot?.map((ele) => {
                            return {
                              value: ele?.startTime,
                              label: ele?.startTime,
                            };
                          })}
                          placeholder="Select Start Time"
                          value={
                            data?.regularTimingFrom !== null
                              ? {
                                value: data?.regularTimingFrom,
                                label: data?.regularTimingFrom,
                              }
                              : null
                          }
                          styles={colourStyles}
                          components={{
                            Option,
                            DropdownIndicator: () => (
                              <img
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  marginRight: "10px",
                                  cursor: isPageEdit && "pointer",
                                }}
                                src="./images/arrowdown.png"
                              />
                            ),
                            IndicatorSeparator: () => null,
                          }}
                          onChange={(e) =>
                            setModalPopupDetail({
                              type: "regularTimingFrom",
                              value: e?.value,
                            })
                          }
                          isDisabled={!isPageEdit}
                        />
                        <input
                          tabIndex={-1}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0 }}
                          value={data?.regularTimingFrom === null && ""}
                        />
                      </div>
                      <h2 className="select-end-time">To</h2>
                      <div>
                        <Select
                          options={sortToTiming?.map((ele) => {
                            return {
                              value: ele,
                              label: ele,
                            };
                          })}
                          placeholder="Select End Time"
                          value={
                            sortToTiming?.filter(
                              (ele) => ele === data?.regularTimingTo
                            )?.[0] !== undefined
                              ? {
                                value: data?.regularTimingTo,
                                label: data?.regularTimingTo,
                              }
                              : null
                          }
                          styles={colourStyles}
                          components={{
                            Option,
                            DropdownIndicator: () => (
                              <img
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  marginRight: "10px",
                                  cursor: isPageEdit && "pointer",
                                }}
                                src="./images/arrowdown.png"
                              />
                            ),
                            IndicatorSeparator: () => null,
                          }}
                          onChange={(e) =>
                            setModalPopupDetail({
                              type: "regularTimingTo",
                              value: e?.value,
                            })
                          }
                          isDisabled={!isPageEdit}
                        />
                        <input
                          tabIndex={-1}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0 }}
                          value={
                            sortToTiming?.filter(
                              (ele) => ele === data?.regularTimingTo
                            )?.[0] === undefined && ""
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {data?.regularTimingFrom && (
                  <>
                    <div className="working-day-header d-flex align-items-center flex-wrap mt-4">
                      <h2>Fill Time Slots Available :</h2>
                    </div>
                    <div className="working-day-section__timing">
                      {weekRecords?.map((ele, index) => {
                        return (
                          <div
                            className="form-check form-check-inline"
                            key={index}
                          >
                            <input
                              type="checkbox"
                              // name={ele?.label}
                              // value={data?.[ele?.value]}
                              // onClick={(e) =>
                              //   isPageEdit &&
                              //   data?.[ele?.value] &&
                              //   changeHandler(
                              //     ele?.value,
                              //     e.target.checked ? true : false
                              //   )
                              // }
                              checked={data?.[ele?.value]}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={ele?.label}
                              className="margin-right"
                            >
                              {ele?.label}
                            </label>
                            &nbsp;
                            <span
                              style={{ pointerEvents: !isPageEdit && "none" }}
                              className="Select-Time"
                              data-bs-toggle="modal"
                              data-bs-target="#SelectTimeModal"
                              onClick={async () => {
                                await setWeekSlotData(
                                  data[ele?.value] ? data[ele?.slots] : null
                                );
                                await setIsOpenSelectTime(true);
                                await setWeekSlotName(ele);
                              }}
                            >
                              <img
                                src="https://live.healthassure.in/ProvidersPortal/images/timing-icon.svg"
                                alt="Time Icon"
                              />
                              &nbsp;&nbsp;
                              <span className="text">Select Time</span>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
              <div
                className="modal fade"
                id="staticWorkingHours"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div className="modal-content modal-content-active-popup">
                    <div className="modal-header modal-header-active-popup"></div>
                    <div className="modal-body modal-body-active-popup popup-text">
                      After changing the working hours you will have to
                      re-select the time slots, do you still want to continue ?
                    </div>
                    <div className="modal-footer modal-footer-active-popup popup-text">
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        onClick={async () => {
                          setData({
                            ...data,
                            [modalPopupDetail?.type]: modalPopupDetail?.value,
                            isMondayWorking: false,
                            isTuesdayWorking: false,
                            isWednesdayWorking: false,
                            isThursdayWorking: false,
                            isFridayWorking: false,
                            isSaturdayWorking: false,
                            isSundayWorking: false,
                            mondayTimeSlots: null,
                            tuesdayTimeSlots: null,
                            wednesdayTimeSlots: null,
                            thursdayTimeSlots: null,
                            fridayTimeSlots: null,
                            saturdayTimeSlots: null,
                            sundayTimeSlots: null,
                          });
                          await dispatch(
                            getWorkingHoursSlotAction(
                              modalPopupDetail?.type === "regularTimingFrom"
                                ? modalPopupDetail?.value
                                : data?.regularTimingFrom,
                              modalPopupDetail?.type === "regularTimingTo"
                                ? modalPopupDetail?.value
                                : data?.regularTimingTo
                            )
                          );
                        }}
                        style={{ width: "90px" }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-logout-no"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          setData({
                            ...data,
                          });
                        }}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <FacilitiyImage isPageEdit={isPageEdit} source={source}/>
              <div className="mt-4 mb-2 text-end">
                {isShowSubmitButton && !isPageEdit && (
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={async () => {
                      await dispatch(
                        SubmitApprovalRequestAction("InfrastructureDetail")
                      );
                      await dispatch(getInfrastructureDetailsAction());
                      await dispatch(
                        ViewRequestStatusAction("InfrastructureDetail")
                      );
                      window.location.pathname.includes(
                        ROUTES.PROVIDER_ASSIST
                      ) &&
                        (await dispatch(
                          addProviderAssitLogAction({
                            providerId: getProviderPortalId(),
                            moduleName: "InfrastructureDetail",
                            actionFlag: "S",
                          })
                        ));
                    }}
                  >
                    SUBMIT
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      {/* Select Time Modal  */}
      <div
        className="modal fade"
        id="SelectTimeModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered modal-sm">
          {isOpenSelectTime && (
            <SlotPickerPopup
              data={data}
              setData={setData}
              weekSlotData={weekSlotData}
              weekSlotName={weekSlotName}
              setIsOpenSelectTime={setIsOpenSelectTime}
              setWeekSlotData={setWeekSlotData}
              setWeekSlotName={setWeekSlotName}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InfrastructureDetails;
